 
export const buildDownloadUrl = (relativePath) => {
  const base = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
  const p = String(relativePath || "").trim();

  if (!p) return "";
  // normaliza backslashes por si el back llega a devolverlos
  const cleaned = p.replace(/\\/g, "/");

  // si ya viene absoluta, la devolvemos tal cual
  if (/^https?:\/\//i.test(cleaned)) return cleaned;

  // asegura que arranque con /
  const withSlash = cleaned.startsWith("/") ? cleaned : `/${cleaned}`;
  return `${base}${withSlash}`;
};

export const triggerDownload = (relativePath, fileName = "archivo") => {
  const fullUrl = buildDownloadUrl(relativePath);
  if (!fullUrl) return;

  const isAndroid = /Android/i.test(navigator.userAgent);

  if (isAndroid) {
    window.open(fullUrl, "_blank");
    return;
  }

  const link = document.createElement("a");
  link.href = fullUrl;
  link.download = fileName; // algunos servidores ignoran esto, pero ayuda
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


export function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName || "download";
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}